var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinus = function SvgMinus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Minus",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-33.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-7",
    transform: "translate(33.000000, 165.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Minus",
    transform: "translate(33.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9669204,7.5 C13.2430628,7.5 13.4669204,7.72385763 13.4669204,8 C13.4669204,8.24545989 13.2900452,8.44960837 13.056796,8.49194433 L12.9669204,8.5 L3.09553048,8.5 C2.81938811,8.5 2.59553048,8.27614237 2.59553048,8 C2.59553048,7.75454011 2.77240564,7.55039163 3.00565485,7.50805567 L3.09553048,7.5 L12.9669204,7.5 Z",
    id: "Icons/16/Minus"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "minus.4736c9804d6ce060c7ade6a00cd4672e.svg";